import React from "react";

interface ListSkeletonProps {
  /** Number of placeholder rows to render. */
  count?: number;
  /** "card" mimics the Agent Registry's .agent-card-nav (avatar + 2 lines + tag row). "row" is a slimmer single-line item for compact lists like Runs/Flows. */
  variant?: "card" | "row";
  className?: string;
}

/**
 * Shared loading placeholder — first established for the Agent Registry list
 * and reused everywhere else in the app (Run History, Workflow Manager, …) so
 * every panel shows the same shimmering skeleton treatment instead of ad-hoc
 * spinners, matching the app's theme tokens in both light and dark mode.
 */
export const ListSkeleton: React.FC<ListSkeletonProps> = ({ count = 4, variant = "card", className = "" }) => {
  return (
    <div className={`flex flex-col gap-2 px-3 py-2 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-2.5 p-2.5 rounded-xl border border-edge bg-card"
        >
          <div className="w-8 h-8 rounded-lg shimmer shrink-0" style={{ animationDelay: `${i * 90}ms` }} />
          <div className="flex-1 min-w-0 flex flex-col gap-1.5">
            <div className="h-2.5 rounded shimmer" style={{ width: `${55 + (i % 3) * 10}%`, animationDelay: `${i * 90}ms` }} />
            {variant === "card" && (
              <div className="h-2 rounded shimmer" style={{ width: `${75 - (i % 3) * 8}%`, animationDelay: `${i * 90 + 60}ms` }} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
